<template>
  <div id="hrms73e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :maxRowspan="maxRowspan.index"
            :receivedStore="receivedHrms73eIndex"
            :editEvent="editEvent"
            :deleteInlineEventBool="true"
            :saveInlineEvent="deleteEvent"
            searchBoxAlias="hrms73e"
            :callSearchEvent="callSearchEvent" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :searchIndex="searchIndex"
            :indexSelected="indexSelected"
            :lovCurrentDesc="lovCurrentDesc"
            :receivedHrms73eDetail="receivedHrms73eDetail"
            :tab1Table="columns[app.nowLang].columnsTab1"
            :detail="detail"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :codeval="codempid"
            :disableForm="disableForm"
            :descCodeval="app.currentUser.username[app.nowLang]"
            :postHrms73eSave="postHrms73eSave"
            :receivedHrms73eDetailForm="receivedHrms73eDetailForm"/>
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms73e/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import detail from 'components/hrms73e/detail'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import moment from 'moment'

export default {
  name: 'hrms73e',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        year: moment().format('YYYY')
      }
    }
  },
  created () {
    this.receivedHrms73eColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    descCodempid () {
      let currentUser = this.app.currentUser
      return currentUser.username[this.app.nowLang]
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS73E_INDEX_DISP,
      detailDisp: types.GET_HRMS73E_DETAIL_DISP,
      maxRowspan: types.GET_HRMS73E_MAX_ROWSPAN,
      columns: types.GET_HRMS73E_COLUMNS,
      labels: types.GET_HRMS73E_LABELS,
      index: types.GET_HRMS73E_INDEX,
      indexSelected: types.GET_HRMS73E_INDEX_SELECTED,
      detail: types.GET_HRMS73E_DETAIL,
      disableForm: types.GET_HRMS73E_DISABLE_CODFORM,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC
    })
  },
  methods: {
    pageDetail (event, param) {
      switch (event) {
        case 'edit':
          if (this.indexSelected.codempid) {
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.currentDtereq = this.indexSelected.dtereq
            this.receivedHrms73eDetail({ searchIndex: this.searchIndex, indexSelected: this.indexSelected })
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    editEvent (param) {
      let objParam = Object.assign({}, param)
      objParam.val_code = objParam.val_code || this.codempid
      objParam.val_name = objParam.val_name || this.descCodempid
      objParam.val_date = objParam.val_date || moment().format('DD/MM/YYYY')
      this.setIndexSelected(objParam)
      this.pageDetail('edit')
    },
    // deleteEvent (param) {
    //   this.setIndexSelected(param)
    //   if (this.indexSelected.staappr === 'P') {
    //     let sendParams = {
    //      // dteyear
    //      // codcours
    //       numclseq: this.indexSelected.numseq,
    //       codempid: this.indexSelected.codempid,
    //       val_code: this.indexSelected.val_code,
    //       val_date: this.indexSelected.val_date,
    //       codform: this.indexSelected.codform
    //     }
    //     this.postHrms73eCancel(sendParams)
    //   } else if (this.indexSelected.staappr === 'C') {
    //     swal({
    //       title: constLabels('warningTitle'),
    //       text: constLabels('HR1506'),
    //       confirmButtonText: constLabels('ok')
    //     })
    //   } else {
    //     swal({
    //       title: constLabels('warningTitle'),
    //       text: constLabels('HR1490'),
    //       confirmButtonText: constLabels('ok')
    //     })
    //   }
    // },
    deleteEvent (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms73eCancel({ searchIndex: this.searchIndex, dataRowsHasFlg: dataRowsHasFlg })
        }
      })
    },
    callSearchEvent () {
      if (this.searchIndex.codempid3 !== '') {
        this.searchIndex.codcomp = ''
        this.searchIndex.codpos = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS73E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS73E_PAGE,
      receivedHrms73eColumnsLabels: types.RECEIVED_HRMS73E_COLUMNS_LABELS,
      receivedHrms73eIndex: types.RECEIVED_HRMS73E_INDEX,
      receivedHrms73eDetail: types.RECEIVED_HRMS73E_DETAIL,
      receivedHrms73eDetailForm: types.RECEIVED_HRMS73E_DETAIL_FORM,
      postHrms73eSave: types.POST_HRMS73E_SAVE,
      postHrms73eCancel: types.POST_HRMS73E_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?0d900a3f